import React, { useEffect, useState } from 'react';
import { AppConstant } from '../../../../../Assests/AppConstant';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getAuthReducer } from '../../../../../../redux/reducers/reducerSlices/AuthReducer';
import DrilldownTable from '../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import CommonToggleSwitch from '../../../../Common/CommonToggleSwitch/CommonToggleSwitch';
import { initiateSearch, formatContactNumNNN, showAlert } from '../../../../../Assests/Utility';
import _ from 'lodash';
import Popup from '../../../../Common/Popup/Popup';
import { toast } from 'react-toastify';
import EditIcon from '../../../../../Assests/Images/edit-icon-new.png';


const UserTable = (props) => {
    const navigate = useNavigate();
    const { themeSelected, allowPermissionA, allowPermissionD, editUserAction, searchStr, allowPermissionR } = props;
    const [userListData, setUserListData] = useState([]);
    const [resenEmailLoader, setResenEmailLoader] = useState(false)
    const [resetUserPassLoader, setResetUserPassLoader] = useState(false)
    const user = useSelector(getUserSelector)
    const { initateLoading, userList, userType, arrangeOrder, arrangeKey, cu_id, parentWarehouse, resendEmail, resetUserPass } = user;
    const userAuth = useSelector(getAuthReducer);
    const { user_name } = userAuth;
    const dispatch = useDispatch()
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null)
    const [deletingUserId, setDeletingUserId] = useState(null)

    useEffect(() => {
        dispatch({ type: sagaActions.INITIATE_LOADING, payload: true })
        setTimeout(() => {
            dispatch({ type: sagaActions.UPDATE_USER_LIST, payload: createPayload() })
        },[0])
    }, [])

    useEffect(() => {
        if (userList.length) {
            initateLoading && dispatch({ type: sagaActions.INITIATE_LOADING, payload: false })
            if (searchStr) {
                const searchedByUsername = initiateSearch(userList, searchStr, 'UserName');
                const searchedByCarrier = initiateSearch(userList, searchStr, 'CarrierName');
                const searchedArr = _.uniqBy([...searchedByUsername, ...searchedByCarrier], 'UserID');
                setUserListData(searchedArr);
            } else {
                setUserListData(userList);
            }
            setSelectedObj(null)
            setDeletingUserId(null)
        }
    }, [userList])

    useEffect(() => {
        if (searchStr.length > 3) {
            const searchedByUsername = initiateSearch(userList, searchStr, 'UserName');
            const searchedByCarrier = initiateSearch(userList, searchStr, 'CarrierName');
            const searchedArr = _.uniqBy([...searchedByUsername, ...searchedByCarrier], 'UserID');
            setUserListData(searchedArr);
        } else if (searchStr === '') {
            setUserListData(userList)
        }
    }, [searchStr])

    useEffect(() => {
        if(resendEmail){
            setResenEmailLoader(false)
            dispatch({ type: sagaActions.UPDATE_RESEND_EMAIL, payload: false})
        }
    },[resendEmail])

    useEffect(() => {
        if(resetUserPass){
            setResetUserPassLoader(false)
            dispatch({ type: sagaActions.UPDATE_RESET_USER_PASSWORD, payload: false})
        }
    },[resetUserPass])

    const createPayload = () => {
        return {
            user_name: user_name, email: user_name, user_type: userType, enable_status: 0, cu_id:  null, crud_type: 'S', first_name: null, last_name: null, phone: null,
            p_cu_id: userType === AppConstant.userPermission.usertypes.superAdmin ||
            userType === AppConstant.userPermission.usertypes.administrator  ? null : cu_id,
            warehouseId: userType === AppConstant.userPermission.usertypes.superAdmin ||
            userType === AppConstant.userPermission.usertypes.administrator ? null :parentWarehouse.ID
        }
    }

    const updatePayload = (user) => {
        return {
            user_name: user.UserName, email: user.Email, user_type: user.UserType, enable_status: user.EnableStatus, cu_id: user.CUID, crud_type: 'U', first_name: user.FirstName, last_name: user.LastName, phone: user.Phone,
            p_cu_id: userType === AppConstant.userPermission.usertypes.superAdmin ||
            userType === AppConstant.userPermission.usertypes.administrator ? null : cu_id,
            warehouseId: userType === AppConstant.userPermission.usertypes.superAdmin ||
            userType === AppConstant.userPermission.usertypes.administrator ? null :parentWarehouse.ID
        }
    }
    const warehouseTitleDD = [
        { id: 'serial_num',   name: 'S.No',         style: { width: '55px',  minWidth: '55px'  } },
        { id: 'UserName',     name: 'User Name',     style: { minWidth: '130px' } },
        { id: 'UserType',     name: 'User Type',     style: { minWidth: '120px' } },
        { id: 'RolesAssigned',name: 'App Type', style: { minWidth: '130px' } },
        { id: 'CarrierName',  name: 'Carrier Name',  style: { minWidth: '130px' } },
        { id: 'Email',        name: 'Email',         style: { minWidth: '170px' } },
        { id: 'FirstName',    name: 'First Name',    style: { minWidth: '100px' } },
        { id: 'LastName',     name: 'Last Name',     style: { minWidth: '100px' } },
        { id: 'Phone',        name: 'Phone Number',  style: { minWidth: '130px' } },
        { id: 'CreatedOn',    name: 'Created on',    style: { minWidth: '110px' } },
        { id: 'LastLogon',    name: 'Last Logon',    style: { minWidth: '110px' } },
        { id: 'status',       name: 'Status',        style: { width: '80px',  minWidth: '80px'  } },
        { id: 'actions',      name: 'Actions',       style: { minWidth: '130px' } },
    ]

    const clickHandler = (key, user) => {
        dispatch({ type: sagaActions.UPDATE_SELECTED_USER, payload: user })
        switch (key) {
            case AppConstant.commonStrings.edit:
                editUserAction(user)
                break;
            case AppConstant.commonStrings.disable:
                dispatch({ type: sagaActions.UPDATE_USER_LIST, payload: { user_name: user.UserName,
                    p_cu_id: cu_id,
                    warehouseId: userType === AppConstant.userPermission.usertypes.superAdmin ||
            userType === AppConstant.userPermission.usertypes.administrator ? null :parentWarehouse.ID,
                     crud_type: 'D' } })

                break;
            case AppConstant.commonStrings.assign:
                dispatch({ type: sagaActions.RESET_USER_ROLE_ASSIGN })
                navigate('/user/assign')
                break;
            case AppConstant.commonStrings.resendEmail:
                setResenEmailLoader(user.CUID)
                dispatch({ type: sagaActions.INITIATE_RESEND_EMAIL, payload: { username: user.Email } })
                break;
            case AppConstant.commonStrings.resetPassword:
                setResetUserPassLoader(user.CUID)
                dispatch({ type: sagaActions.INITIATE_RESET_USER_PASSWORD, payload: { username: user.Email } })
                break;
            case AppConstant.commonStrings.deleteUser:
                setSelectedObj(user)
                setShowDeleteModel(true)    
                break;
            default:
                break;
        }
    }

    const toggleStatus = (data,index) => {
        const response = _.find(userList, { 'UserID': data.UserID});
        let tempObj = {...response}
        if(!_.isEmpty(tempObj)){
             let tempArr = JSON.parse(JSON.stringify(userListData));
            tempObj.EnableStatus = !tempArr[index].EnableStatus;
        tempArr[index] = tempObj;
        setUserListData(tempArr)
        dispatch({ type: sagaActions.UPDATE_USER_LIST, payload: updatePayload(tempObj) })
        }
       
    }


    const getToggleSwitch = (data, value, index) => {
        return (
            <div className='d-flex justify-content-center align-items-center py-1'>
                <CommonToggleSwitch value={value}
                    onChangeValue={(e) => toggleStatus(data,index)} allowPermissionD={allowPermissionD}/>
            </div>
        )

    }

    const actionsButton = (el) => {
        return (
            <div className='d-flex flex-row align-items-center gap-2'>
                {/* Edit — edit-icon-new.png (same image used in SsPOListSS reference) */}
                {/* <img
                    src={EditIcon}
                    alt="Edit User"
                    title="Edit"
                    className={`action-icon-img ${allowPermissionA ? '' : 'opacity-50'}`}
                    style={{ cursor: allowPermissionA ? 'pointer' : 'not-allowed', color: "black"}}
                    onClick={allowPermissionA ? () => clickHandler(AppConstant.commonStrings.edit, el) : undefined}
                    data-bs-toggle={allowPermissionA ? 'modal' : undefined}
                    data-bs-target={allowPermissionA ? '#createUserFormPopup' : undefined}
                /> */}
                <button
                    title="Edit"
                    onClick={
                        allowPermissionA
                            ? () => clickHandler(AppConstant.commonStrings.edit, el)
                            : undefined
                    }
                    className={`action-icon-btn no-bg no-border ${
                        allowPermissionA ? "" : "opacity-50"
                    }`}
                    style={{ cursor: allowPermissionA ? "pointer" : "not-allowed" }}
                    data-bs-toggle={allowPermissionA ? "modal" : undefined}
                    data-bs-target={allowPermissionA ? "#createUserFormPopup" : undefined}
                    disabled={!allowPermissionA}
                >
                    <i className="fa-solid fa-pen-to-square"style={{ fontSize: "16px" }}></i>
                </button>
                {/* Assign */}
                <button
                    title="Assign"
                    onClick={() => clickHandler(AppConstant.commonStrings.assign, el)}
                    className="action-icon-btn no-bg no-border action-icon-assign"
                >
                    <i className="fa-solid fa-user-tag"style={{ fontSize: "16px" }}></i>
                </button>
                {/* Reset Password */}
                <button
                    title="Reset Password"
                    onClick={() => clickHandler(AppConstant.commonStrings.resetPassword, el)}
                    className={`action-icon-btn no-bg no-border action-icon-key ${allowPermissionR ? '' : 'opacity-50'}`}
                    disabled={!allowPermissionR}
                >
                    {el.CUID === resetUserPassLoader
                        ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        : <i className="fa-solid fa-key"style={{ fontSize: "16px" }}></i>
                    }
                </button>
                {/* Delete User — fa-regular fa-trash-can (same icon class used in SsPOListSS reference) */}
                <button
                    title="Delete User"
                    onClick={() => clickHandler(AppConstant.commonStrings.deleteUser, el)}
                    className="action-icon-btn no-bg no-border action-icon-delete"
                >
                    {el.CUID === deletingUserId
                        ? <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true"></span>
                        : <i className="fa-regular fa-trash-can"style={{ fontSize: "16px" }}></i>
                    }
                </button>
            </div>
        )
    }

       /**
     * delete popup handler to delete the records based on the confirmation
     * @param {*} text 
     */
const popupBtnHandler = (text) => {
    if (text === AppConstant.commonStrings.no) {
        setShowDeleteModel(false)
        setSelectedObj(null)
    }
    else {
        if(_.upperCase(cu_id) === _.upperCase(selectedObj?.CUID)){
            showAlert(toast.TYPE.ERROR, 'You cannnot delete yourself, contact DB team.', themeSelected)
            setShowDeleteModel(false)
            setSelectedObj(null)
            return
        } else {
            let tempData = {
                user_name: selectedObj?.Email,
                crud_type: 'R',
                cu_id: selectedObj?.CUID,
                DeletedBy: cu_id
           }
            // Only now start the spinner — user confirmed deletion
            setDeletingUserId(selectedObj?.CUID)
            dispatch({ type: sagaActions.DELETE_USER, payload: tempData })
        }
    }
    setShowDeleteModel(false)
    setSelectedObj(null)
    }
    
     /**
     * Helper to show the delete conformation pop-up
     * @returns 
     */
     const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteConfirmation',
            modalLabel: 'showDeleteConfirmation',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: `Delete user`,
            bodyText: `${AppConstant.commonStrings.areYouSure} delete user - ${selectedObj?.UserName} ? This would completely delete all user data and all access assigned to user.`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.no
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text) }} closepopup={() => { setShowDeleteModel(false); setSelectedObj(null); }} themeSelected={themeSelected} showModal={showDeleteModel} />
    }

    const formatListData = (data) => {
        return data.map((el, index) => {
            return {
                id: `${el.UserID}_${el.LastName}`,
                0: el.serial_num,
                1: el.UserName || '-',
                2: el.UserType || '-',
                3: el.RolesAssigned || '-',
                4: el.CarrierName || '-',
                5: el.Email,
                6: el.FirstName || '-',
                7: el.LastName || '-',
                8: el.Phone ? formatContactNumNNN(el.Phone) : '-',
                9: el.CreatedOn,
                10: el.LastLogon || '-',
                11: getToggleSwitch(el, el.EnableStatus, index),
                12: actionsButton(el),
            }
        })
    }

    return (
        <>
        <DrilldownTable
            themeSelected={themeSelected}
            bodyData={userListData.length && formatListData(userListData)}
            titleData={warehouseTitleDD}
            showCollapse={false}
            showInput={false}
            showSort={true}
            arrangeOrder={arrangeOrder}
            arrangeKey={arrangeKey}
            drillDownReport={userList}
            initiateDrillDownReport={initateLoading}
            loaderArray={13}
            sortingAction={sagaActions.SORT_USER_TABLE}
            subRoot={{ pathName: 'user' }}
            showUTCTime={false}
            />
            {showDeleteConfirmation()}
            </>
    )
}

export default UserTable;